import React from 'react';
import { FaChevronRight } from 'react-icons/fa';
import serializers from '../serializers';
import { RawPortableText } from '../types';
import BlockContent from '@sanity/block-content-to-react';

import * as styles from './InfoBox.module.scss';
import { Link } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { LinkReference } from '../graphql-fragments/LinkReference';
import { getReferenceUrl } from '../utils/utils';

type InfoBoxProps = {
  backgroundColor: string;
  title: string;
  content: RawPortableText;
} & (
  | {
      readMoreUrl?: string;
      readMoreReference?: never;
    }
  | {
      readMoreUrl?: never;
      readMoreReference?: {
        internal: {
          type: 'SanityProduct' | 'SanityCrop' | 'SanityNewsArticle' | 'SanityResourceArticle';
        };
        slug: {
          current: string;
        };
      };
    }
);

const InfoBox = ({
  backgroundColor,
  title,
  content,
  readMoreReference,
  readMoreUrl,
}: InfoBoxProps): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <section className={styles.infoBox}>
      <div className={styles.container + (backgroundColor === 'blue' ? ' ' + styles.blueBg : '')}>
        <h4 className={styles.title}>{title}</h4>
        <BlockContent className={styles.text} blocks={content} serializers={serializers} />
        {(readMoreUrl || readMoreReference) && (
          <div className={styles.button}>
            <Link
              to={
                readMoreReference
                  ? getReferenceUrl(readMoreReference.internal.type, readMoreReference.slug.current)
                  : readMoreUrl!
              }
              className={styles.link}
            >
              {t('article.infobox.read_more_link', 'Read More')}
              <FaChevronRight className={styles.icon} />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default InfoBox;
